import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCol,
  CFormLabel,
  CNav,
  CNavItem,
  CNavLink,
  CRow,
  CTabContent,
  CTabPane,
} from '@coreui/react'
import moment from 'moment'
import SearchTable from 'src/components/searchTable'
import useAxios from 'axios-hooks'
import { AFFILIATES_ANALYTICS_API } from '../../utils/urls'
import { AppContext } from '../../context/app'
import { useParams } from 'react-router-dom'
import getSymbolFromCurrency from 'currency-symbol-map'
import { sum } from 'lodash'
import { exportToExcel } from 'react-json-to-excel'

const AffiliateAnalyticsDetail = () => {
  const { affiliateId } = useParams()
  const { setLoader } = useContext(AppContext)
  const [activePane, setActivePane] = useState(1)

  const [{ data: affiliateDetail, loading: affiliateDetailLoading }] = useAxios({
    url: AFFILIATES_ANALYTICS_API,
    method: 'get',
    params: {
      affiliate_id: affiliateId,
    },
  })

  const activeTab = { color: '#1976d2', fontSize: '1.1rem' }
  const inActiveTab = { color: '#191818', fontSize: '1.1rem' }

  useEffect(() => {
    setLoader(affiliateDetailLoading)
  }, [affiliateDetailLoading])

  const userTableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 20,
    },
    {
      header: 'Email',
      dataCell: (info) => info.email_id,
      width: 19,
    },
    {
      header: 'Status',
      dataCell: (info) => (info.status ? 'Active' : 'In Active'),
      width: 16,
    },
    {
      header: 'Signup Date',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 15,
    },
  ]

  const transactionTableConfig = [
    {
      header: 'Subscriber Name',
      dataCell: (info) => info.user.name,
      width: 20,
    },
    {
      header: 'Subscriber Email',
      dataCell: (info) => info.user.email_id,
      width: 19,
    },
    {
      header: 'Transaction Amount',
      dataCell: (info) => getSymbolFromCurrency(info.currency) + info.transaction_amount,
      width: 16,
    },
    {
      header: 'Discount Code',
      dataCell: (info) => info.discount_code,
      width: 15,
    },
    {
      header: 'Transaction Date',
      dataCell: (info) => moment.utc(info.transaction_date).format('DD-MM-YYYY'),
      width: 15,
    },
  ]

  const exportData = () => {
    const userData = affiliateDetail.data.users.map((user) => ({
      Name: user.name,
      Email: user.email_id,
      'User Status': user.status ? 'Active' : 'In Active',
      'Signup Date': moment.utc(user.created_date).format('DD-MM-YYYY'),
    }))

    const transactionData = affiliateDetail.data.transactions.map((txn) => ({
      'Subscriber Name': txn.user.name,
      'Subscriber Email': txn.user.email_id,
      'Transaction Amount': getSymbolFromCurrency(txn.currency) + txn.transaction_amount,
      'Discount Code': txn.discount_code,
      'Transaction Date': moment.utc(txn.transaction_date).format('DD-MM-YYYY'),
    }))

    const exportData = [
      {
        sheetName: 'Sign up',
        details: userData,
      },
      {
        sheetName: 'Transactions',
        details: transactionData,
      },
    ]

    exportToExcel(exportData, 'affiliate-analytics', true)
  }

  return (
    <>
      <h4>Affiliate analytics detail</h4>
      {affiliateDetail && affiliateDetail.data && (
        <CCard style={{ padding: '1rem' }}>
          <CRow>
            <CCol lg="1">
              <CFormLabel className={'fw-bolder'}>Name :</CFormLabel>
            </CCol>
            <CCol lg="3">
              <p>{affiliateDetail.data.name}</p>
            </CCol>
            <CCol lg="1">
              <CFormLabel className={'fw-bolder'}>Email :</CFormLabel>
            </CCol>
            <CCol lg="3">
              <p>{affiliateDetail.data.email}</p>
            </CCol>
            <CCol lg="1">
              <CFormLabel className={'fw-bolder'}>Mobile :</CFormLabel>
            </CCol>
            <CCol lg="2">
              <p>{affiliateDetail.data.mobile}</p>
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="2">
              <CFormLabel className={'fw-bolder'}># Signup :</CFormLabel>
            </CCol>
            <CCol lg="2">
              <p>{affiliateDetail.data.users.length}</p>
            </CCol>
            <CCol lg="2">
              <CFormLabel className={'fw-bolder'}># Transactions :</CFormLabel>
            </CCol>
            <CCol lg="1">
              <p>{affiliateDetail.data.transactions.length}</p>
            </CCol>
            <CCol lg="3">
              <CFormLabel className={'fw-bolder'}>Total transaction amount :</CFormLabel>
            </CCol>
            <CCol lg="2">
              <p>
                {affiliateDetail.data.transactions.length > 0
                  ? getSymbolFromCurrency(affiliateDetail.data.transactions[0].currency) +
                    sum(affiliateDetail.data.transactions.map((item) => item.transaction_amount))
                  : 0}
              </p>
            </CCol>
          </CRow>
          <CRow className={'justify-content-end'}>
            <CCol lg="2">
              <CButton
                className="text-white"
                color="info"
                onClick={exportData}
                style={{ pointerEvents: 'auto' }}
              >
                Export
              </CButton>
            </CCol>
          </CRow>
        </CCard>
      )}
      <CRow className="mt-3">
        <CNav variant="tabs">
          <CNavItem>
            <CNavLink
              style={activePane === 1 ? activeTab : inActiveTab}
              className="px-5"
              active={activePane === 1}
              onClick={() => setActivePane(1)}
            >
              Signup Users
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={activePane === 2 ? activeTab : inActiveTab}
              className="px-5"
              active={activePane === 2}
              onClick={() => setActivePane(2)}
            >
              Transactions
            </CNavLink>
          </CNavItem>
        </CNav>
        <CTabContent>
          <CTabPane role="tabpanel" visible={activePane === 1}>
            {affiliateDetail && affiliateDetail.data && (
              <SearchTable
                titleText={'Signup Users'}
                tableCardHeight={50}
                disableButton={true}
                searchTerm={`name`}
                tableContent={affiliateDetail.data.users}
                tableConfig={userTableConfig}
                createPermission={false}
                type={'affiliate signup'}
              />
            )}
          </CTabPane>
          <CTabPane role="tabpanel" visible={activePane === 2}>
            {affiliateDetail && affiliateDetail.data && (
              <SearchTable
                tableCardHeight={50}
                disableButton={true}
                searchTerm={`Subscriber Name`}
                tableContent={affiliateDetail.data.transactions}
                tableConfig={transactionTableConfig}
                createPermission={false}
                type={'affiliate transactions'}
              />
            )}
          </CTabPane>
        </CTabContent>
      </CRow>
    </>
  )
}

export default AffiliateAnalyticsDetail
